// src/components/SplashScreen.jsx
import React from "react";
export default function SplashScreen() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100dvh" }}>
      <div>
        <div style={{ fontSize: 28, fontWeight: 700, textAlign: "center" }}>
          Your App
        </div>
        <div style={{ textAlign: "center", opacity: 0.7 }}>starting…</div>
      </div>
    </div>
  );
}
